// Software project thumbnails
import cribxpert from "../../Assets/Images/Cribxpert.png";
import calApp from "../../Assets/Images/Calculator App.png";
import Crypto from "../../Assets/Images/CryptoJacking.png";
import Faq from "../../Assets/Images/FAQs.png";
import TechTrybe from "../../Assets/Images/TechTrybe.png";
import Google from "../../Assets/Images/Google Front Page.png";
import TekkTopia from "../../Assets/Images/TekkTopia.png";
import ai from "../../Assets/Images/AI-powered Chabot.png";
import metro from "../../Assets/Images/MetroGasOnline.png";
import palindrome from "../../Assets/Images/Palindrome Image.png";
import schoolivio from "../../Assets/Images/Schoolivio.jpg";
import topiadesk from "../../Assets/Images/Topiadesk.jpg";
import topZest from "../../Assets/Images/TopZest.jpg";
import motrix from "../../Assets/Images/MotrixMobility.jpg";
// Systems engineering thumbnails
import intuneImg from "../../Assets/Images/intuneportal.png";
import erpImg from "../../Assets/Images/gradient-erp-illustration_23-2149370943.jpg";
import m365Img from "../../Assets/Images/Information Technology Support.jpg";
import ucImg from "../../Assets/Images/close-up-man-s-hand-using-his-mobile-phone.jpg";

export const SYSTEMS_PROJECTS = [
  {
    img: intuneImg,
    category: "Systems Engineering",
    title: "Microsoft Intune Implementation",
    text: "End-to-end endpoint management deployment securing and standardizing an organization's entire device fleet.",
    tags: ["Intune", "Autopilot", "Conditional Access", "M365"],
    caseStudy: {
      client: "Enterprise client (NDA)",
      role: "IT Systems Engineer",
      duration: "~6 weeks",
      challenge:
        "The organization had a growing, unmanaged mix of company and personal (BYOD) devices with no central control. Software was installed manually, security baselines were inconsistent, there was no enforced encryption or patch compliance, and lost or stolen devices posed a real data-leak risk. Onboarding a new staff member meant a full day of manual setup.",
      solution:
        "I designed and rolled out a complete Microsoft Intune (Endpoint Manager) environment. I enrolled Windows, iOS and Android devices, built compliance and configuration policies (BitLocker encryption, password rules, firewall and update baselines), deployed applications centrally, and wired in Conditional Access so only compliant devices could reach company data. Windows Autopilot enabled zero-touch provisioning — a new device now configures itself on first sign-in.",
      roadblocks: [
        "Aligned licensing (M365 E3/E5 + Intune) before enrollment could begin — clarified entitlements with the client to avoid gaps.",
        "Configured the Apple MDM Push (APNs) certificate to manage iOS devices, and renewed the annual certificate process with documentation.",
        "Tested Conditional Access carefully in a pilot group to avoid locking legitimate users out before company-wide rollout.",
        "Migrated existing on-prem Group Policy settings into equivalent Intune configuration profiles.",
        "Handled user adoption — ran short enrollment guides and a phased rollout to reduce pushback.",
      ],
      outcome:
        "The client gained full visibility and control over every device, enforced encryption and compliance across the fleet, and cut new-device setup from hours to minutes with Autopilot — significantly reducing both security risk and IT workload.",
    },
  },
  {
    img: erpImg,
    category: "Systems Engineering",
    title: "Odoo ERP Deployment",
    text: "Self-hosted ERP rollout unifying inventory, fleet, CRM and accounting for a global logistics company.",
    tags: ["Odoo", "Ubuntu Server", "PostgreSQL", "Nginx"],
    caseStudy: {
      client: "Global logistics company",
      role: "IT Systems Engineer",
      duration: "~10 weeks",
      challenge:
        "The company ran its operations across disconnected spreadsheets and standalone tools. Inventory, fleet, purchasing, CRM and accounting lived in separate silos, so there was no single source of truth. Reconciling data between branches was manual and error-prone, and management had little real-time visibility into stock or cash flow.",
      solution:
        "I deployed and configured a self-hosted Odoo ERP covering Inventory, Purchase, CRM, Accounting, Project and Fleet. Rather than a shared cloud tier, I provisioned a dedicated Linux (Ubuntu) server for performance and full data control, set up PostgreSQL, fronted the app with an Nginx reverse proxy and SSL, defined user roles and approval workflows, migrated and cleaned legacy data, and trained the team.",
      roadblocks: [
        "Procured and provisioned a dedicated Ubuntu server — the shared hosting on hand couldn't meet the performance and data-ownership requirements.",
        "Tuned PostgreSQL and worker/resource settings so the ERP stayed responsive under multi-branch concurrent use.",
        "Configured Nginx as a reverse proxy with SSL and set up automated database + filestore backups for disaster recovery.",
        "Cleaned and reconciled messy legacy spreadsheet data before importing it into Odoo's structured models.",
        "Drove user adoption with role-based training so staff trusted the system over their old spreadsheets.",
      ],
      outcome:
        "The business moved from scattered spreadsheets to one integrated platform with real-time visibility across inventory, fleet and finance — eliminating manual reconciliation, tightening stock control, and giving management dependable, branch-wide reporting.",
    },
  },
  {
    img: m365Img,
    category: "Systems Engineering",
    title: "Microsoft 365 Onboarding & Mail Migration",
    text: "Migrated a construction company off legacy hosting onto Microsoft 365 with zero data loss.",
    tags: ["Microsoft 365", "Exchange Online", "Migration", "MFA"],
    caseStudy: {
      client: "Construction company",
      role: "IT Systems Engineer",
      duration: "~3 weeks",
      challenge:
        "The company's mailboxes were hosted on a legacy Aruba IT (aruba.it) setup with limited storage, weak security, and no integrated collaboration tooling. Staff couldn't easily share files or coordinate, and the platform offered little protection against modern email threats.",
      solution:
        "I onboarded the company onto Microsoft 365 — provisioning the tenant, migrating all mailboxes from Aruba to Exchange Online, and reconfiguring DNS (MX, SPF, DKIM, DMARC) for secure, reliable mail flow. I set up Outlook profiles, rolled out SharePoint, OneDrive and Teams for collaboration, and applied a security baseline including multi-factor authentication.",
      roadblocks: [
        "Planned the mailbox cutover to preserve full email history and minimize downtime during the switch.",
        "Managed DNS propagation timing so mail flow was never interrupted during the MX change.",
        "Validated SPF/DKIM/DMARC to keep migrated mail out of spam folders.",
        "Rolled out MFA with clear guidance so security improved without frustrating non-technical site staff.",
      ],
      outcome:
        "The company moved to a modern, secure Microsoft 365 environment with all mail history intact, larger mailboxes, built-in collaboration through Teams and SharePoint, and MFA-backed security — with virtually no disruption to daily operations.",
    },
  },
  {
    img: ucImg,
    category: "Systems Engineering",
    title: "Unified Communications — Teams Direct Routing",
    text: "Modernized enterprise telephony with Microsoft Teams Phone and an Airtel SIP trunk via a certified SBC.",
    tags: ["MS Teams Phone", "Direct Routing", "SBC", "SIP Trunk", "VoIP"],
    caseStudy: {
      client: "Oil & gas company",
      role: "IT Systems Engineer",
      duration: "~5 weeks (phased)",
      challenge:
        "The business relied on a traditional PBX system that kept voice calling separate from its collaboration tools. Call costs were high, the legacy hardware was inflexible, and there was no unified experience between chat, video and external phone calls.",
      solution:
        "I implemented Microsoft Teams Phone with Direct Routing, letting staff make and receive external (PSTN) calls directly inside Teams. I deployed and configured a certified Session Border Controller (SBC) as the secure gateway between Teams and the carrier, established a SIP trunk with Airtel for external calling, and configured DNS, firewall rules, voice policies, dial plans, call queues and auto-attendants — then validated everything through a pilot before a phased company-wide rollout.",
      roadblocks: [
        "Specified and procured a certified SBC — Teams can't connect to a SIP trunk directly, so the right gateway hardware/software was essential.",
        "Validated firewall and network configuration for SIP traffic and opened the correct ports for media and signaling.",
        "Coordinated SIP trunk setup and connectivity testing with Airtel as the PSTN provider.",
        "Tuned call routing and ran call-quality tests during the pilot to fix audio and routing issues before full rollout.",
        "Confirmed Teams Phone licensing and rolled out in phases with user training to smooth adoption.",
      ],
      outcome:
        "The company retired its legacy PBX and unified voice, video, chat and external calling inside Microsoft Teams — lowering call costs, simplifying IT management, and giving staff features like call queues, auto-attendants and voicemail transcription on a single, scalable platform.",
    },
  },
];

export const SOFTWARE_PROJECTS = [
  {
    img: schoolivio,
    title: "Schoolivio",
    text: "An all-in-one school management platform — admissions, fees, exams, results, timetable, attendance, school email, payroll and accounts, with an AI assistant.",
    tags: ["React", "Supabase"],
    href: "https://schoolivio.com/",
  },
  {
    img: topiadesk,
    title: "Topiadesk",
    text: "A customer support platform bringing helpdesk, WhatsApp, SLA monitoring and IT asset management into one workspace for modern African teams.",
    tags: ["Next.js", "SaaS"],
    href: "https://www.topiadesk.com/",
  },
  {
    img: motrix,
    title: "MOTRIX Mobility",
    text: "The official MOTRIX Mobility website — presenting e-hailing fleet operations, vehicle rentals, haulage and fleet management services across Nigeria.",
    tags: ["React", "Tailwind"],
    href: "https://www.motrixmobility.com/",
  },
  {
    img: topZest,
    title: "Top-Zest Professionals",
    text: "The official Top-Zest Professionals website — presenting accounting, payroll, tax and business advisory services for businesses across Nigeria.",
    tags: ["Web", "Brand"],
    href: "https://www.top-zest.com/",
  },
  {
    img: cribxpert,
    title: "Cribxpert",
    text: "The official Cribxpert website — presenting the brand's property and technology offerings with a clean, informative experience.",
    tags: ["Web", "Brand"],
    href: "https://cribxpert.com",
  },  {
    img: TekkTopia,
    title: "Tekktopia Website",
    text: "Showcasing brand, products and services with informative content to attract customers.",
    tags: ["Web", "Brand"],
    href: "https://www.tekktopia.com/",
  },  {
    img: Crypto,
    title: "Crypto-Jacking Detection",
    text: "Detects and prevents unauthorized cryptocurrency mining activity on computer systems and networks.",
    tags: ["Python", "Streamlit"],
    href: "https://danialosh.streamlit.app/",
  },  {
    img: Google,
    title: "Google Landing Page",
    text: "A custom Google front page clone that reflects my design and layout preferences.",
    tags: ["HTML", "CSS"],
    href: "https://danieloshinubi.github.io/frontpagehub/",
  },  {
    img: ai,
    title: "AI-Powered Chatbot",
    text: "A customer-support chatbot that understands and responds to user queries efficiently and accurately.",
    tags: ["AI", "JavaScript"],
    href: "https://amazone-chatbot.netlify.app/",
  },
  {
    img: calApp,
    title: "Web-Based Calculator",
    text: "A responsive calculator app for performing mathematical calculations quickly and accurately.",
    tags: ["React", "CSS"],
    href: "https://calculator-app-frontend-eight.vercel.app/",
  },
  {
    img: Faq,
    title: "FAQ Dropdown",
    text: "An accessible FAQ accordion that surfaces answers to common user questions.",
    tags: ["React", "UI"],
    href: "https://faqs-dropdown.vercel.app/",
  },
  {
    img: TechTrybe,
    title: "TechTrybe Official Website",
    text: "World-class technology solutions tailored to address business needs and ensure seamless operational growth.",
    tags: ["Web", "Brand"],
    href: "https://www.thetechtrybe.com/home",
  },
  {
    img: metro,
    title: "Metro Gas Online",
    text: "An online ordering and delivery system for gas — from browsing to checkout.",
    tags: ["React", "E-commerce"],
    href: "https://metro-gas-shop-and-deliver.vercel.app/",
  },
  {
    img: palindrome,
    title: "Palindrome Checker",
    text: "A tool that checks whether a word, sentence, or number reads the same backward and forward.",
    tags: ["JavaScript", "UI"],
    href: "https://palindrome-word-check.netlify.app/",
  },
];

/** Pick projects by title, preserving the given order. */
export const pickByTitle = (titles) => {
  const all = [...SYSTEMS_PROJECTS, ...SOFTWARE_PROJECTS];
  return titles
    .map((t) => all.find((p) => p.title === t))
    .filter(Boolean);
};
